import React from 'react';
import { employer, validationFlags } from '../../data/mockData';

const criticalCount = validationFlags.filter(f => f.severity === 'CRITICAL').length;

const NAV = [
  { id: 'dashboard', icon: '⬡', label: 'Dashboard' },
  { id: 'pipeline', icon: '⬣', label: 'Pipeline Runner' },
  { id: 'divider1', divider: true, label: 'Data Layers' },
  { id: 'employer', icon: '🏢', label: 'Employer Config' },
  { id: 'employees', icon: '👥', label: 'Employee Profiles' },
  { id: 'workbook', icon: '📋', label: 'Workbook Output' },
  { id: 'divider2', divider: true, label: 'Pipeline Output' },
  { id: 'validation', icon: '🔎', label: 'Validation Flags', badge: criticalCount },
  { id: 'loader', icon: '⬆', label: 'API Loader Results' },
  { id: 'reconciliation', icon: '✓', label: 'Reconciliation' },
  { id: 'audit', icon: '🗒', label: 'Audit Log' },
];

export default function Sidebar({ page, setPage }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo-mark">PrimePay</div>
        <div className="logo-sub">Payroll Pipeline v3</div>
      </div>

      <div className="sidebar-client">
        <div className="client-label">Active Client</div>
        <div className="client-name">{employer.companyName}</div>
        <div className="client-id">{employer.clientId}</div>
      </div>

      <nav className="sidebar-nav">
        {NAV.map(item => item.divider
          ? <div key={item.id} className="nav-section-label" style={{ marginTop: 12 }}>{item.label}</div>
          : (
            <button
              key={item.id}
              className={`nav-item ${page === item.id ? 'active' : ''}`}
              onClick={() => setPage(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
              {item.badge ? <span className="nav-badge">{item.badge}</span> : null}
            </button>
          )
        )}
      </nav>
    </aside>
  );
}
